import React from 'react';
import classNames from 'classnames';

import {
  withSettings,
  IWithSettingsProps,
} from '../../../../../components/context/settings';
import { withTPA, IWithTPAProps } from '../../../../../components/context/tpa';
import {
  withI18n,
  IWithI18nProps,
} from '../../../../../components/context/i18n';

import compose from '../../../../../lib/utils/compose';

import getStyles from './EpisodesSearch.styles';
import styles from './EpisodesSearch.scss';

interface IEpisodesSearchResultsProps
  extends IWithSettingsProps,
    IWithTPAProps,
    IWithI18nProps {
  query: string;
  isLoading: boolean;
  hasResults: boolean;
  onSearch(query: string): void;
}

class EpisodesSearchResults extends React.Component<IEpisodesSearchResultsProps> {
  handleReset = () => {
    this.props.onSearch('');
  };

  render() {
    const { query, isLoading, hasResults, settings, tpa, t } = this.props;
    const dynamicStyles = getStyles({
      colors: settings.colors.main,
      fonts: settings.fonts.main,
      deviceType: tpa.params.deviceType,
      mainSettings: settings.main,
    });

    return (
      (query && !isLoading && !hasResults && (
        <div
          data-hook="main.episodes.search-no-results"
          className={styles.noResults}
        >
          <div
            className={classNames(
              styles.noResultsText,
              dynamicStyles.noResultsText,
            )}
          >
            {t('pages.main.search.no-results-text-1', { query })}
            <br />
            {t('pages.main.search.no-results-text-2')}
          </div>
          <button
            data-hook="main.episodes.search-no-results-reset"
            className={classNames(
              styles.noResultsResetButton,
              dynamicStyles.noResultsResetButton,
            )}
            type="button"
            onClick={this.handleReset}
          >
            {t('pages.main.search.no-results-reset-button-text')}
          </button>
        </div>
      )) ||
      null
    );
  }
}

export default compose(withSettings, withTPA, withI18n)(EpisodesSearchResults);
